export const errors = {
    404: {
        message: 'Not Found'
    },
    0: {
        message: 'Unknown Error'
    },
    'default': {
        message: 'Something went wrong. Unable to find the issue'
    }
};
